import { getTimezonePreferenceQueryKeyPart, type AppTimezonePreference } from '@sparkai/utils'

import { getSelectedTimezoneHeaders } from '../timezoneRequestContext'

// eslint-disable-next-line sonarjs/function-return-type
export function getOperatorPerformanceQueryTimezonePart(timezonePreference?: AppTimezonePreference) {
  const timezoneQueryKeyPart = timezonePreference
    ? getTimezonePreferenceQueryKeyPart(timezonePreference)
    : undefined
  return timezoneQueryKeyPart
}

// eslint-disable-next-line sonarjs/function-return-type
export function getOperatorPerformanceRequestHeaders(timezonePreference?: AppTimezonePreference) {
  const headers = timezonePreference ? getSelectedTimezoneHeaders(timezonePreference) : undefined
  const requestHeaders = headers && Object.keys(headers).length ? headers : undefined
  return requestHeaders
}
